/** Mirrors NETWORKING_CATEGORIES in serverless/common/event/networkingMapTypes.ts. */
export const NETWORKING_CATEGORY_FILTERS = [
  { key: "jurisdiction", label: "Jurisdiction" },
  { key: "areasOfPractice", label: "Areas of Practice" },
  { key: "previousEvents", label: "Previous Events" },
  { key: "languages", label: "Languages" },
  { key: "region", label: "Region" },
  { key: "additionalOffices", label: "Additional Offices" },
] as const;

export type NetworkingCategoryKey =
  (typeof NETWORKING_CATEGORY_FILTERS)[number]["key"];

export const ALL_NETWORKING_CATEGORY_KEYS: NetworkingCategoryKey[] =
  NETWORKING_CATEGORY_FILTERS.map((category) => category.key);
